/**
 * Helper function for creating a singleton
 * @param create factory function
 */
export default function makeSingleton(create) {
  let singleton;
  return function getInstance() {
    if (typeof singleton === 'undefined') {
      singleton = create();
    }

    return singleton;
  };
}